<script>
    import { keydownWrapper } from '$lib/app/lib.js';
    import Flag from '$lib/app/Flag.svelte';

    let {
        nswe,
        map = null
    } = $props();

    let lat = $state();
    let lon = $state();

    lat = DDtoDMS(nswe.lat, 'S', 'N');
    lon = DDtoDMS(nswe.lon, 'W', 'E');

    /*
        Converts decimal format to DMS ( Degrees / minutes / seconds )
        dir1, dir2 = 'S','N' or 'W', 'E'
    */
    function DDtoDMS(dec, dir1, dir2)  {
        if(dec === undefined)
            return undefined;
        const vars = (dec + "").split(".");
        const deg = Math.abs(vars[0]);
        let tempma = vars[1] ? ("0." + vars[1]) : 0;
        tempma = tempma * 3600;
        const min = Math.floor(tempma / 60);
        const sec = tempma - (min * 60);
        if(!deg && !min) 
            return "0°";
        else {
            // &hairsp - \u200A
            // \u202F - NARROW NO-BREAK SPACE
            return `${deg}°\u202F${min}′\u202F${(dec < 0) ? dir1 : dir2}`; 
        }
    }

    function flyTo(e) {
        e.preventDefault();
        if(map) {
            map.flyTo({center: [nswe.lon, nswe.lat], zoom: 10, speed: 15 });
        }
    }
</script>


{#if nswe !== undefined && nswe?.name}
    <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
    <span role="button" class=flyable-text onclick={flyTo} onkeydown={keydownWrapper(flyTo)} tabindex=0>{nswe.name}</span>
    <Flag reg={nswe?.unp} width=auto/> ({lat}, {lon})
{/if}


<style>
    .flyable-text {
        cursor: zoom-in;
        border-bottom: 1px dashed #000;
        text-decoration: none;
    }
</style>
